/* OXS — site-wide cursor-follower red glow (handoff hero effect, global).
   Fine pointers only; respects prefers-reduced-motion. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const glow = document.createElement('div');
  glow.className = 'oxs-cursor-glow';
  glow.setAttribute('aria-hidden', 'true');
  // Inline display beats Dawn's `div:empty { display: none }` which would hide
  // this (intentionally empty) element.
  glow.style.display = 'block';
  document.body.appendChild(glow);

  let px = 0, py = 0, ticking = false, visible = false;
  document.addEventListener('mousemove', (e) => {
    px = e.clientX;
    py = e.clientY;
    if (!visible) { glow.classList.add('is-on'); visible = true; }
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(() => {
        glow.style.transform = `translate(${px}px, ${py}px) translate(-50%, -50%)`;
        ticking = false;
      });
    }
  }, { passive: true });

  document.addEventListener('mouseleave', () => {
    glow.classList.remove('is-on');
    visible = false;
  });
})();
